import { createBrowserRouter, Navigate } from 'react-router-dom'
import { SignedIn, SignedOut, RedirectToSignIn } from '@clerk/clerk-react'
import App from './ui/App'
import LandingPage from './ui/landing/LandingPage'
import LandingPageV2 from './ui/landing/LandingPageV2'
import TermsPage from './ui/landing/TermsPage'
import PrivacyPage from './ui/landing/PrivacyPage'
import { SignInPage, SignUpPage, OnboardingFlow } from './ui/components'

/**
 * Protected route wrapper - requires authentication.
 * Redirects to sign-in if not authenticated.
 */
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  // Check if Clerk is configured
  const clerkEnabled = !!import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

  if (!clerkEnabled) {
    // If Clerk is not configured, allow access (dev mode)
    return <>{children}</>
  }

  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  )
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <LandingPageV2 />,
  },
  {
    path: '/landing-v1',
    element: <LandingPage />,
  },
  {
    path: '/sign-in/*',
    element: <SignInPage />,
  },
  {
    path: '/sign-up/*',
    element: <SignUpPage />,
  },
  {
    path: '/onboarding',
    element: <OnboardingFlow />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/app',
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
  },
  {
    path: '/app/*',
    element: (
      <ProtectedRoute>
        <App />
      </ProtectedRoute>
    ),
  },
  {
    // Redirect any unknown routes to landing
    path: '*',
    element: <Navigate to="/" replace />,
  },
])
